import { api } from '@/api'
import to from '@/modules/await-to-js'

const state = {
  gateway: {}
}

export const getters = {
  gateway: state => state.gateway
}

export const mutations = {
  setGateway (state, gateway) {
    state.gateway = gateway
  }
}

export const actions = {
  // get gateway by gateway EUI
  async getGateway (context, eui) {
    let error, response
    [error, response] = await to(api.getGateway(context.rootGetters.application, eui))
    if (error || !response) return Promise.reject(error)

    // So... in order to avoid background task to pull server for gateway stats every 10 seconds, the value is
    // set back to false :(
    if(response.data.connection === true && response.data.connection_way === 'VPN')
    {
      response.data.connection = false
    }

    context.commit('setGateway', response.data)
    return Promise.resolve(response)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
